import React from 'react';
import CustomDiscountsDataRows from './CustomDiscountsDataRows';

const summaryStyle = {
    display: 'flex',
    border: '1px solid #d7d7d7',
    boxSizing: 'border-box',
    height: 35,
    alignItems: 'center',
    justifyContent: 'flex-start',
    color: '#414141',
    fontFamily: 'roboto',
    fontWeight: 500,
    position: 'relative',
    backgroundColor: '#ffffff'
};

const CustomDiscountsTable = ({
    campaign,
    discountData = [],
    onChange,
    readOnly,
    discountGiven,
    effectiveDiscount,
    activeRequest = {},
    ...props
}) => {
    const headHeight = 30;
    const visibleActiveRows = 5;
    const rowHeight = 30;
    const totalHeight = rowHeight * visibleActiveRows + headHeight;

    /**
     * Generates the gridTemplateAreas css to fit the data
     */
    const generateGridTemplateAreas = () => {
        // active grid headers
        let retVal = `'discountH maximumH amountH gutterH'`;
        // active grid data
        for (let i = 0; i < discountData.length || i < visibleActiveRows; i++) {
            retVal = `
                ${retVal}
                'discount${i} maximum${i} amount${i} ${
                i < visibleActiveRows ? 'gutter' : '.'
            }'
            `;
        }

        // middle bit with tickboxes
        retVal = `
            ${retVal}
            'mid mid mid mid'
        `;

        return retVal;
    };

    return (
        <div {...props}>
            <div
                style={{
                    display: 'grid',
                    boxSizing: 'border-box',
                    gridTemplateColumns: '435px 147px 147px 19px',
                    gridTemplateAreas: generateGridTemplateAreas(),
                    backgroundColor: '#ffffff',
                    overflowY: 'hidden',
                    height: totalHeight
                }}
            >
                <CustomDiscountsDataRows
                    data={discountData}
                    onChange={onChange}
                    rowHeight={rowHeight}
                    visibleRows={visibleActiveRows}
                    activeRequest={activeRequest}
                    readOnly={readOnly}
                />
            </div>
            <div style={{ display: 'flex' }}>
                <div
                    style={{
                        ...summaryStyle,
                        width: 435,
                        fontSize: 13,
                        borderWidth: '0 1px 1px 1px',
                        justifyContent: 'center'
                    }}
                >
                    <span>{`${window.translate('Discount given as')}:`}</span>
                    <span style={{ fontWeight: 'bold', paddingLeft: 3 }}>
                        {window.translate(discountGiven)}
                    </span>
                </div>
                <div
                    style={{
                        ...summaryStyle,
                        width: 147,
                        fontSize: 15,
                        borderWidth: '0 0 1px 1px',
                        alignItems: 'flex-end',
                        paddingBottom: 5.5
                    }}
                >
                    <span style={{ paddingLeft: 10 }}>
                        {window.translate('Effective Discount')}
                    </span>
                </div>
                <div
                    style={{
                        ...summaryStyle,
                        width: 166,
                        fontSize: 20,
                        borderWidth: '0 1px 1px 0',
                        alignItems: 'flex-end',
                        paddingBottom: 4.5
                    }}
                >
                    <span style={{ paddingLeft: 8 }}>{effectiveDiscount}%</span>
                </div>
            </div>
        </div>
    );
};

export default CustomDiscountsTable;
